<template>
  <v-container>
    <span v-if="loadingOSProjs">
      <loading-progress
        :progress="10"
        indeterminate
        size="64"
        shape="semicircle"
        rotate
        hide-background
        fillDuration="2"
        rotationDuration="1"
      />
    </span>
    <h1 v-if="!osprojs || (osprojs&&osprojs.length<1)">{{loading}}</h1>
    <span v-for="osproj in osprojs" :key="osproj.id">
      <v-card target="_blank" elevation="0.5" max-width="100%" class="margin">
        <v-row>
          <v-card-title class="padding-low">
            <v-col cols='12' class="title">
              <h1 class="title">{{osproj.title}}</h1>
            </v-col>
          </v-card-title>
          <v-card-text>
            <v-row class="row-align">
              <v-col class="padding-low" cols='12'>
                <p class="text" v-html="osproj.description"/>
              </v-col>
              <v-col class="text padding-low" v-for='file in osproj.files' :key="file.name" cols='12' sm='6' md='4'>
                <a class="text hasLink" target="_blank" :href="file.url">{{file.name}}</a>
              </v-col>
            </v-row>
          </v-card-text>
        </v-row>
      </v-card>
    </span>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "OpenSourceContent",
  computed: mapState(["loadingOSProjs", "osprojs"]),
  data(){
    return{
      loading:'Content is loading...',
    }
  },
  mounted() {
    
    if (!this.osprojs.length) this.$store.dispatch("cargarOSProjs");
    console.log(this.osprojs.length)

  }
};
</script>

<style scoped>

.title{
  text-align: left;
}

.margin{
  margin-bottom: 10px;
}

.text{
  text-align: left;
}

.padding-low{
  padding-bottom: 5px;
  padding-top: 5px;
}

.row-align{
  padding-left: 15px;
  padding-right: 15px;
}

.divider {
  margin-top: .5rem;
  margin-bottom: .5rem;
}

.hasLink {
  color: #b80b0b !important;
}

.row{
  margin-top: -5px;
  margin-bottom: -5px;
}

</style>